import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRelationship } from "../api/deleteRelationship";

export const useDeleteRelationship = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ endPoint, id, body }) => deleteRelationship(endPoint, id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allRelationship"] });
    },
  });
};

